export default class  AssetReportActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_ASSETREPORT='GET_HELPER_ASSETREPORT';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static BEFORE_PRINT_ASSETREPORT='BEFORE_PRINT_ASSETREPORT';
  static PRINT_ASSETREPORT='PRINT_ASSETREPORT';
  static submit(){
    return {
      type:  AssetReportActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type:  AssetReportActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type:  AssetReportActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type:  AssetReportActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type:  AssetReportActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type:  AssetReportActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type:  AssetReportActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type:  AssetReportActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type:  AssetReportActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type:  AssetReportActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type:  AssetReportActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type:  AssetReportActions.GET_HELPER_ASSETREPORT,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type:  AssetReportActions.ERROR_SERVER,
      payload: error
    };
  }
  static beforePrint(){
    return {
      type: AssetReportActions.BEFORE_PRINT_ASSETREPORT,
    };
  }
  static print(printAssetReport){
    return {
      type: AssetReportActions.PRINT_ASSETREPORT,
      payload: printAssetReport
    };
  }
}